import Vector2 from "./Vector2";
class Rectangle {
    static equals(r1, r2) {
        return r1.Left === r2.Left && r1.Right === r2.Right && r1.Top === r2.Top && r1.Bottom === r2.Bottom;
    }
    static edgeSizeEquals(r1, r2) {
        return r1.Width === r2.Width && r1.Height === r2.Height;
    }
    constructor(left, bottom, width, height) {
        this._left = left;
        this._bottom = bottom;
        this._width = width;
        this._height = height;
    }
    get Left() {
        return this._left;
    }
    get Right() {
        return this.Left + this.Width;
    }
    get Top() {
        return this._bottom + this._height;
    }
    get Bottom() {
        return this._bottom;
    }
    get Width() {
        return this._width;
    }
    get Height() {
        return this._height;
    }
    contains(xOrPoint, y) {
        let x;
        if (xOrPoint instanceof Vector2) {
            x = xOrPoint.X;
            y = xOrPoint.Y;
        }
        else {
            x = xOrPoint;
        }
        return this.Left <= x && this.Right >= x && this.Top <= y && this.Bottom >= y;
    }
    toLocal(xOrPoint, y) {
        let x;
        if (xOrPoint instanceof Vector2) {
            x = xOrPoint.X;
            y = xOrPoint.Y;
        }
        else {
            x = xOrPoint;
        }
        x -= this.Left;
        y -= this.Bottom;
        return xOrPoint instanceof Vector2 ? new Vector2(x, y) : [x, y];
    }
    toLocalNormalized(xOrPoint, y) {
        if (xOrPoint instanceof Vector2) {
            const v = this.toLocal(xOrPoint);
            return new Vector2(v.X / this.Width, v.Y / this.Height);
        }
        else {
            const v = this.toLocal(xOrPoint, y);
            return [v[0] / this.Width, v[1] / this.Height];
        }
    }
    toAbsolute(xOrPoint, y) {
        if (xOrPoint instanceof Vector2) {
            return new Vector2(xOrPoint.X + this.Left, xOrPoint.Y + this.Top);
        }
        else {
            return [xOrPoint + this.Left, y + this.Top];
        }
    }
    toString() {
        return `Rectangle(${this.Left},${this.Top}-${this.Right},${this.Bottom})`;
    }
}
export default Rectangle;



// WEBPACK FOOTER //
// ./src/Rectangle.ts